import Vue from 'vue'
import Vuex from 'vuex'

//import qs from 'qs';
Vue.use(Vuex)

export default ({
  namespaced: true,
  getters: {
    followUp(state) {
      return state.followUp
    },
    followUps(state) {
      return state.followUps
    },
    getFormOptions(state) {
      return state.formOptions
    }
  },
  actions: {
    clearFollowUp(context) {
      context.commit('setFollowUp', {})
    },
    async saveFollowUp(context, followUp) {
      let formData = new FormData()

      Object.keys(context.state.followUp).forEach((item, i) => {
        if (context.state.followUp[item] && context.state.followUp[item].toString().length)
          formData.append(item, context.state.followUp[item])
      });
      return await Vue.axios.post('/api/followUp/save', formData).then((res) => {
        return res.data
      })
    },
    setFollowUp(context, followUp) {
      context.commit('setFollowUp', followUp)
    },
    loadFollowUps(context, caseID) {
      Vue.axios.get('/api/followUp/list', {
        params: {
          case: caseID
        }
      }).then((res) => {
        context.commit('setFollowUps', JSON.parse(res.data))
      })
    },
    async loadFormOptions(context,caseID) {
      return await Vue.axios.get('/api/followUp/formOptions', {
        params: {
          caseID: caseID
        }
      }).then((res) => {
        return context.commit('setFormOptions',res.data)
      })
    }
  },
  mutations: {
    setFollowUp(state, followUp) {
      state.followUp = followUp
    },
    setFollowUps(state, followUps) {
      state.followUps = followUps
    },
    setFormOptions(state, options) {
      state.formOptions = options
    }
  },
  state: {
    followUp: {
      id: null,
      ehrPageNumber: null,
      outputCCDReference: null,
      validationStatus: null,
      cancelFollowUp: null,
      followUpComments: null,
      followUpReviewComments: null,
      qaComments: null
    },
    followUps: [],
    formOptions: []
  }
})